// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Shunt — tiny DOM and formatting helpers.

const ESC: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/** Escape user/peer-supplied text before it goes into innerHTML. */
export function escapeHtml(s: string): string {
  return String(s).replace(/[&<>"']/g, (c) => ESC[c]);
}

/** Format a duration in ms as M:SS. */
export function fmtTime(ms: number): string {
  const t = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(t / 60);
  const s = t % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

/** "12 moves" / "1 move". */
export function moveLabel(n: number): string {
  return `${n} move${n === 1 ? '' : 's'}`;
}

/** "+3" / "on par" — how a score reads against the proven optimum. */
export function parLabel(moves: number, par: number): string {
  const d = moves - par;
  if (d <= 0) return 'on par';
  return `+${d}`;
}

/** "3 wagons" / "1 wagon". */
export function wagonLabel(n: number): string {
  return `${n} wagon${n === 1 ? '' : 's'}`;
}
